import React from 'react';
import './styles/Sidebar.css';
import { Link } from 'react-scroll';

const Sidebar = () => {
  return (
    <div className="Sidebar">
      <aside>
        <ul className="menu">
          <li>
            <Link to="intro" smooth={true} duration={500}>Introduction</Link>
            <ul className="submenu">
              <li><Link to="details" smooth={true} duration={500}>What is PickupLinesAPI?</Link></li>
            </ul>
          </li>
          <li>
            <Link to="docs" smooth={true} duration={500}>API Documentation</Link>
            <ul className="submenu">
              <li><Link to="getRandom" smooth={true} duration={500}>Get random line</Link></li>
              <li><Link to="getAll" smooth={true} duration={500}>Get list of lines</Link></li>
            </ul>
          </li>
          <li>
            <Link to="special" smooth={true} duration={500}>Special Dynamic Routes</Link>
            <ul>
              <li><Link to="category" smooth={true} duration={500}>By Category</Link></li>
              <li><Link to="language" smooth={true} duration={500}>By Language</Link></li>
            </ul>
          </li>
          <li>
            <Link to="interaction" smooth={true} duration={500}>POST Routes</Link>
            <ul>
              <li><Link to="rate" smooth={true} duration={500}>Rate a Pickup Line</Link></li>
              <li><Link to="comment" smooth={true} duration={500}>Comment on a Pickup Line</Link></li>
              <li><Link to="usage" smooth={true} duration={500}>Submit a Usage Example</Link></li>
            </ul>
          </li>
        </ul>
      </aside>
    </div>
  );
};

export default Sidebar;
